/**
 * nodes/definitions/index.ts
 * 全ノード定義をまとめてエクスポートするバレルファイル
 * nodeRegistry.tsx からインポートされる
 */
import type { NodeDefinition, NodeKind } from '../../types';
import { startDefinition } from './start';
import { endDefinition } from './end';
import { inputDefinition } from './input';
import { outputDefinition } from './output';
import { functionDefinition } from './function';
import { textEditDefinition } from './textEdit';
import { sayTextDefinition } from './sayText';
import { gestureDefinition } from './gesture';
import { danceDefinition } from './dance';
import { qrScanDefinition } from './qrScan';
import { tofDefinition } from './tof';
import { listenDefinition } from './listen';
import { ifDefinition } from './if';
import { switchDefinition } from './switch';
import { counterDefinition } from './counter';
import { coinFlipDefinition } from './coinFlip';
import { waitDefinition } from './wait';
import { randomChoiceDefinition } from './randomChoice';
import { keywordSwitchDefinition } from './keywordSwitch';
import { soundEffectDefinition } from './soundEffect';
import { lightDefinition } from './light';
import { customGestureDefinition } from './customGesture';
import { walkingDefinition } from './walking';
import { mazeGoalDefinition } from './mazeGoal';

/**
 * 全ノード定義のマッピング
 * キーはNodeKindと一致する必要がある
 */
export const definitions = {
  start: startDefinition,
  end: endDefinition,
  textEdit: textEditDefinition,
  sayText: sayTextDefinition,
  gesture: gestureDefinition,
  customGesture: customGestureDefinition,
  dance: danceDefinition,
  qrScan: qrScanDefinition,
  tof: tofDefinition,
  listen: listenDefinition,
  if: ifDefinition,
  switch: switchDefinition,
  counter: counterDefinition,
  coinFlip: coinFlipDefinition,
  wait: waitDefinition,
  randomChoice: randomChoiceDefinition,
  keywordSwitch: keywordSwitchDefinition,
  soundEffect: soundEffectDefinition,
  light: lightDefinition,
  input: inputDefinition,
  output: outputDefinition,
  function: functionDefinition,
  walking: walkingDefinition,
  mazeGoal: mazeGoalDefinition,
} satisfies { [K in NodeKind]: NodeDefinition<K> };
